import { render, staticRenderFns } from "./print-invoice-transfer.vue?vue&type=template&id=11044c81&scoped=true&"
import script from "./print-invoice-transfer.vue?vue&type=script&lang=ts&"
export * from "./print-invoice-transfer.vue?vue&type=script&lang=ts&"
import style0 from "./print-invoice-transfer.vue?vue&type=style&index=0&id=11044c81&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11044c81",
  null
  
)

export default component.exports